import {Capacitor} from '@capacitor/core'

import {AppPlatformsEnum} from '../types/graphqlSchema'

const platform = Capacitor.getPlatform() as Lowercase<AppPlatformsEnum>

const isNativeAndroidApp = platform === 'android'
const isNativeIosApp = platform === 'ios'
const isNativeMobileApp = isNativeAndroidApp || isNativeIosApp

export {isNativeAndroidApp, isNativeIosApp, isNativeMobileApp, platform}
export default platform
